import { render, staticRenderFns } from "./PermanentAddressActivity.vue?vue&type=template&id=478c3560&scoped=true&"
import script from "./PermanentAddressActivity.vue?vue&type=script&lang=js&"
export * from "./PermanentAddressActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c3560",
  null
  
)

export default component.exports